/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from "react";
import { isIOS } from "react-device-detect";

export interface IFeatureDatumProps {
    type: "check-list" | "tabs" | "icons";
    imagePosition: "left" | "right";
    image?: string;
    value?:
        | string[]
        | { title?: string; description?: string; remixIcon?: string }[];
    title?: string;
    description?: string;
    buttonLabel?: string;
    buttonLink?: string;
    id: string;
}

export interface IFeatureProps {
    featureSectionId?: string;
    featureLabel?: string;
    featureDescription?: string;
    featureData?: IFeatureDatumProps[];
}
export const Features = ({
    featureSectionId,
    featureLabel,
    featureDescription,
    featureData
}: IFeatureProps) => {
    const _renderHeader = () => {
        if (featureLabel || featureDescription) {
            return (
                <header className="section-header">
                    {featureLabel && <h2>{featureLabel}</h2>}
                    {featureDescription && <p>{featureDescription}</p>}
                </header>
            );
        }
    };

    const _rendercheckList = (_feature: IFeatureDatumProps) => {
        let _aos_props: any = {};
        if (!isIOS) {
            _aos_props = {
                "data-aos": "zoom-in",
                "data-aos-delay": "100"
            };
        }
        let _aos_zoom_out_props: any = {};
        if (!isIOS) {
            _aos_zoom_out_props = {
                "data-aos": "zoom-out",
                "data-aos-delay": "200"
            };
        }
        return (
            <div
                id={_feature?.id}
                className={"row"}
                style={{ marginBottom: "150px" }}
            >
                {_feature?.imagePosition === "left" && (
                    <div className="col-lg-6">
                        <img
                            src={_feature?.image}
                            className="img-fluid"
                            alt=""
                        />
                    </div>
                )}
                {(_feature?.value ||
                    _feature?.title ||
                    _feature.description) && (
                    <div
                        className={`col-lg-${
                            _feature?.image ? 6 : 12
                        } mt-5 mt-lg-0 d-flex`}
                    >
                        <div className="row align-self-center gy-4">
                            {_feature?.title && <h3>{_feature?.title}</h3>}
                            {_feature?.description && (
                                <p>{_feature?.description}</p>
                            )}
                            <div className="col-md-12" {..._aos_props}>
                                {_feature?.buttonLabel && (
                                    <a
                                        href={_feature?.buttonLink ?? "/"}
                                        className="btn-explore"
                                        style={{ marginBottom: "30px" }}
                                    >
                                        {_feature?.buttonLabel}
                                    </a>
                                )}
                            </div>
                            {_feature?.value?.map((_val, index) => (
                                <div
                                    key={`feature-check-list-${index}`}
                                    className="col-md-6"
                                    {..._aos_zoom_out_props}
                                >
                                    <div className="feature-box d-flex align-items-center">
                                        <i className="bi bi-check" />
                                        <h3>{_val}</h3>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
                {_feature?.imagePosition === "right" && (
                    <div className="col-lg-6">
                        <img
                            src={_feature?.image}
                            className="img-fluid"
                            alt=""
                        />
                    </div>
                )}
            </div>
        );
    };

    const _renderFeatureIcon = (_feature: IFeatureDatumProps) => {
        let _aos_fi_props: any = {};
        if (!isIOS) {
            _aos_fi_props = {
                "data-aos": "fade-up"
            };
        }
        let _aos_fr_props: any = {};
        if (!isIOS) {
            _aos_fr_props = {
                "data-aos": "fade-right",
                "data-aos-delay": "100"
            };
        }
        let _aos_fv_props: any = {};
        if (!isIOS) {
            _aos_fv_props = {
                "data-aos": "fade-up",
                "data-aos-delay": "100"
            };
        }
        let _aos_fimg_props: any = {};
        if (!isIOS) {
            _aos_fimg_props = {
                "data-aos": "fade-right",
                "data-aos-delay": "100"
            };
        }
        return (
            <div
                id={_feature?.id}
                className="row feature-icons"
                {..._aos_fi_props}
            >
                {_feature?.title && <h3>{_feature?.title}</h3>}
                {_feature?.description && (
                    <p style={{ textAlign: "center" }}>
                        {_feature?.description}
                    </p>
                )}
                <div className="row">
                    {_feature?.image && _feature?.imagePosition === "left" && (
                        <div
                            className="col-xl-4 text-center"
                            {..._aos_fr_props}
                        >
                            <img
                                src={_feature?.image}
                                className="img-fluid p-4"
                                alt=""
                            />
                        </div>
                    )}
                    <div className={"col-xl-8 d-flex content"}>
                        <div className="row align-self-center gy-4">
                            {_feature?.value?.map((_val, index) => (
                                <div
                                    key={`feature-icon-${index}`}
                                    className="col-md-6 icon-box"
                                    {..._aos_fv_props}
                                >
                                    {_val?.remixIcon && (
                                        <i className={_val.remixIcon} />
                                    )}
                                    <div>
                                        {_val?.title && <h4>{_val.title}</h4>}
                                        {_val?.description && (
                                            <p>{_val.description}</p>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {_feature?.image && _feature?.imagePosition === "right" && (
                        <div
                            className="col-xl-4 text-center"
                            {..._aos_fimg_props}
                        >
                            <img
                                src={_feature?.image}
                                className="img-fluid p-4"
                                alt=""
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    };
    let _aos_props: any = {};
    if (!isIOS) {
        _aos_props = {
            "data-aos": "fade-up"
        };
    }
    return (
        <section id={featureSectionId} className="features">
            <div className="container" {..._aos_props}>
                {_renderHeader()}
                {featureData?.map((_feature, index) => {
                    if (_feature?.type === "check-list") {
                        return (
                            <React.Fragment key={`feature-section-${index}`}>
                                {_rendercheckList(_feature)}
                            </React.Fragment>
                        );
                    } else if (_feature?.type === "icons") {
                        return (
                            <React.Fragment key={`feature-section-${index}`}>
                                {_renderFeatureIcon(_feature)}
                            </React.Fragment>
                        );
                    } else {
                        return (
                            <React.Fragment key={`feature-default-${index}`} />
                        );
                    }
                })}
            </div>
        </section>
    );
};

Features.defaultProps = {
    featureSectionId: "features"
};
